var content = (function (module) {
var css = { id: module.id, exports: {} };
(function (module) {
exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(true);
// Module
exports.push([module.id, "@media screen and (max-width: 500px) {\n  div.homescroll {\n    width: 60%;\n    overflow: auto;\n    white-space: nowrap;\n  }\n  .header {\n    width: 200%;\n  }\n}\n", "",{"version":3,"sources":["NewDashboard.css"],"names":[],"mappings":"AAAA;EACE;IACE,UAAU;IACV,cAAc;IACd,mBAAmB;EACrB;EACA;IACE,WAAW;EACb;AACF","file":"NewDashboard.css","sourcesContent":["@media screen and (max-width: 500px) {\n  div.homescroll {\n    width: 60%;\n    overflow: auto;\n    white-space: nowrap;\n  }\n  .header {\n    width: 200%;\n  }\n}\n"]}]);


})(css);
return css.exports;
}) (module);
var loader = require("/home/ubuntu/trooprbot-ui/node_modules/antd-theme/lib/loadThemedStyles.js");

if(typeof content === "string") content = [[module.id, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;